import { render } from "./ActiveAuctions.vue?vue&type=template&id=21db8a4c&ts=true"
import script from "./ActiveAuctions.vue?vue&type=script&lang=ts"
export * from "./ActiveAuctions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__